'use client';

import { ParsedUrlQuery } from 'querystring';

import { useMemo } from 'react';

import { useSearchParams } from 'next/navigation';

import Typography from '@components/Typography';
import { useDevice } from '@contexts/device';
import CustomIcon from '@components/utils/CustomIcon';
import { InfoIcon } from '@assets/icons';
import { paramsToObject } from '@components/views/utils';

import {
  Container,
  NonSelectedButton,
  SelectedButton,
  Wrapper,
  PackageWrapper,
  Text,
} from './Style';

const CyprusTab = ({
  selectedTab,
  setSelectedTab,
  shouldResearchPackage,
}: {
  selectedTab?: string;
  setSelectedTab?: (string) => void;
  shouldResearchPackage?: boolean;
}) => {
  const { isDesktop } = useDevice();
  const searchParams = useSearchParams();
  const query: ParsedUrlQuery = useMemo(() => {
    return paramsToObject(searchParams?.entries());
  }, [searchParams]);

  return (
    <PackageWrapper>
      <Container>
        <Wrapper>
          {selectedTab === 'hotel' ? (
            <SelectedButton
              onClick={() => setSelectedTab?.('hotel')}
              width={isDesktop ? '152px' : 'auto'}
            >
              <Typography
                variant={isDesktop ? 'Title5' : 'caption3'}
                color='white'
                weight='Bold'
              >
                Sadece Otel
              </Typography>
            </SelectedButton>
          ) : (
            <NonSelectedButton
              onClick={() => setSelectedTab?.('hotel')}
              width={isDesktop ? '152px' : 'auto'}
            >
              <Typography
                variant={isDesktop ? 'Title5' : 'caption3'}
                color='D500'
                weight='Regular'
              >
                Sadece Otel
              </Typography>
            </NonSelectedButton>
          )}
          {selectedTab === 'package' ? (
            <SelectedButton
              onClick={() => setSelectedTab?.('package')}
              width={isDesktop ? '240px' : 'auto'}
            >
              <Typography
                variant={isDesktop ? 'Title5' : 'caption3'}
                color='white'
                weight='Bold'
              >
                Otel + Uçak + Transfer
              </Typography>
            </SelectedButton>
          ) : (
            <NonSelectedButton
              onClick={() => setSelectedTab?.('package')}
              width={isDesktop ? '240px' : 'auto'}
            >
              <Typography
                variant={isDesktop ? 'Title5' : 'caption3'}
                color='D500'
                weight='Regular'
              >
                Otel + Uçak + Transfer
              </Typography>
            </NonSelectedButton>
          )}
        </Wrapper>
      </Container>
      {isDesktop &&
      shouldResearchPackage &&
      query.in &&
      query.out &&
      query.dep ? (
        <Text>
          <CustomIcon icon={InfoIcon} fontSize={24} paletteColor='Blue600' />
          Güncel paket fiyatlarını görüntüleyebilmek için lütfen yeniden arama
          yapınız.
        </Text>
      ) : null}
    </PackageWrapper>
  );
};

export default CyprusTab;
